import React, {useContext} from 'react';
import {useNavigation} from '@react-navigation/native';
import {WebView} from 'react-native-webview';

import {UserContext} from '../contexts/UserContext';
import Api from '../constants/Api';

const LinkBankScreen = () => {
	const {userToken} = useContext(UserContext);
	const {navigate} = useNavigation();

	return (
		<WebView
			source={{uri: `${Api.apiBaseUrl}/banks?user_token=${userToken}&persist=true`}}
			onMessage={() => navigate('Account')}
		/>
	);
};

export default LinkBankScreen;
